import axios from 'axios';
import  React, {use, useEffect, useState} from 'react';


import Cookies from 'js-cookie';
import { useNavigate } from "react-router-dom";

import { FaEdit } from "react-icons/fa";
import { LuDelete } from "react-icons/lu";

import "./styles/ListUsers.css";

import MensajeError from './MensajeError';
import MensajeQuestion from './MensajeQuestion';
import MensajeAlerta from './MensajeAlerta';
import { CgWebcam } from 'react-icons/cg';

import { useConfig } from '../contexts/ConfigContext';
//RePPrA
const ListUsers = () =>{
    const config = useConfig();
    const API_URL = `${config.API_URL}/api/usuario/`;

    const navigate = useNavigate();
    const [items, setItems] = useState([]);
    //ID a elminar
    const [id_eliminar, setId_eliminar] = useState('');

    //Error generico
    const [showError, setShowError] = useState(false);
    const [showError2, setShowError2] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    //Pregunta de confirmacion
    const [showConfirmacion ,setShowConfirmacion] = useState(false);
    const [confirmacionMsg, setConfirmacionMsg] = useState("");
    //Alerta generica
    const [showAlerta, setShowAlerta] = useState(false);
    const [alertaMsg, setAlertaMsg] = useState('');


    const validarAdmin = () =>{
        if(!(Cookies.get("turid") && Cookies.get("turid") === "rid1" )){
            Cookies.remove("turid");
            navigate("/");
        }
    }

    useEffect(() =>{
        validarAdmin();

         //Configuramos axios para que añada al header el respectivo token
        axios.interceptors.request.use(
        (config) => {
            const token = Cookies.get('usr');
            if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
            }
            return config;
        },
        (error) => {
            console.error(error)
        }
        );

        const JSONPagina = {
             "paginaActual": 0,
            "paginaTamano": 0,
            "totalRegistros": 0,
            "totalPaginas": 0,
            "usuariosList": []
        }
        
        const cargarListaUsuarios = async () =>{
            try{
                const response = await axios.post(API_URL + "obtenerUsuarios", JSONPagina, {Authorization: true});
                if(response.status == 200){
                    const JSONResumen = response.data;
                    setItems(JSONResumen.usuariosList);
                }else{
                    setErrorMessage(response.mensaje);
                    setShowError(true);
                }
                
            }catch(error){
                setErrorMessage(error);
                setShowError(true);
            }
        }

        cargarListaUsuarios();

    },[]);



    const handleDesplegarFormEditar = (id_usuario) =>{
        navigate(`/adminPanel/editarUsuario/${id_usuario}`);

    }
    const handleCloseError = () => {
        setShowError(false); // Oculta el mensaje de error cuando el usuario hace clic en "Aceptar"
        setErrorMessage(''); // Opcional: limpia el mensaje de error
    };

    const mostrarConfirmacionEliminacion = (id_usuario, nombre) => {
        var mensaje = `¿Estás seguro de que quieres eliminar a ${nombre}?`
        setConfirmacionMsg(mensaje);
        setShowConfirmacion(true);
        setId_eliminar(id_usuario);
    }

    const handleEliminarUsuario = async() =>{
        

        //Configuramos axios para que añada al header el respectivo token
        axios.interceptors.request.use(
        (config) => {
            const token = Cookies.get('usr');
            if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
            }
            return config;
        },
        (error) => {
            console.error(error)
        }
        );

    
        const JSONreq = {
                id_usuario: String(id_eliminar)
        }

        console.log(JSONreq)
        //const URL_API = 'http://localhost:5054';

        try{
            const absolutePath = API_URL + 'eliminar';
            const response = await axios.post(absolutePath, JSONreq, {Authorization: true})

            if(response.status === 200){
                setShowAlerta(true);
                setAlertaMsg(response.data.mensaje);

            }else if(response.status === 201){
                setShowAlerta(true);
                setAlertaMsg(response.data.mensaje);
            }else{
                setShowError2(true);
                setErrorMessage(response.data.mensaje);

            }
        }catch(error){
            if(error.status === 400){
                 setShowError2(true);
                setErrorMessage(error.response.data);
            }else{
                setShowError2(true);
                setErrorMessage(error);
            }
        }
    }
    
    const handleCancelEliminacion = () =>{
        setConfirmacionMsg('');
        setShowConfirmacion(false);
    }

    const handleRedireccionarConfirmacion = () =>{
        window.location.reload(); 
    }

    if (showError) return (
        <div>No se ha podido obtener la lista del servidor</div>
    );

    return(

        <div className='LU-MAIN'>
            <MensajeError mensaje={errorMessage} show={showError2} onClose={handleCloseError}/>
            <MensajeQuestion mensaje={confirmacionMsg} show={showConfirmacion} opcion1={handleEliminarUsuario} onClose={handleCancelEliminacion}/>
            <MensajeAlerta mensaje={alertaMsg} show={showAlerta} onClose={handleRedireccionarConfirmacion}/>
            <table className='LU-table'>
                <thead className='LU-thead'>
                    <tr className='LU-Tr'>
                        <th className='LU-Th'>ID usuario</th>
                        <th className='LU-Th'>Nombre</th>
                        <th className='LU-Th'>Correo</th>
                        <th className='LU-Th'>Rol</th>
                        <th className='LU-Th'></th>
                        <th className='LU-Th'></th>
                    </tr>
                
                </thead>
                <tbody>
                    {!showError && items.map((item) =>(
                        <tr className='LU-Tr' key={item.id_usuario}>
                            <td className='LU-Td'>{item.id_usuario}</td>
                            <td className='LU-Td'>{item.nombre}</td>
                            <td className='LU-Td'>{item.correo}</td>
                            <td className='LU-Td'>{item.rol === 1 ? 'Administrador' : 'Usuario'}</td>
                            <td className='LU-Td'><button className="buttonStandartGreen" onClick={() => handleDesplegarFormEditar(item.id_usuario)}><FaEdit size="16px"/></button></td>
                            <td className='LU-Td'><button className='buttonStandartRed' onClick={() => mostrarConfirmacionEliminacion(item.id_usuario, item.nombre)}><LuDelete size="17px"/></button></td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}


export default ListUsers;
